import React from 'react';
import { SButton } from '@chargebee/sting-react';
import { CBRetentionLogo } from '@bbkAdminComponents/cbretention-logo';
import { Label } from '@bbkAdminComponents/inputs/label/label';
import { LogInError } from '@bbkAdminComponents/log-in-flow/error';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import type * as LogInTypes from '@bbkAdminComponents/log-in-flow/log-in-types';
import { LogInSuccess } from '@bbkAdminComponents/log-in-flow/success';
import { LogInTrouble } from '@bbkAdminComponents/log-in-flow/trouble';

type ForgotPasswordTypes = {
  error?: LogInTypes.Error;
  success?: LogInTypes.Success;
  formValues: LogInTypes.FormValues;
  sendResetPassword: LogInTypes.SendResetPassword;
  sending: LogInTypes.Sending;
};

export const ForgotPassword: React.FC<ForgotPasswordTypes> = ({
  error,
  success,
  sending,
  formValues,
  sendResetPassword,
}) => {
  const { email, setEmail } = formValues;
  return (
    <div>
      <form target="#" onSubmit={sendResetPassword}>
        <div className="content">
          <CBRetentionLogo className="tw-mb-6 tw-h-10" />
          <div className="tw-mb-4 tw-font-semibold">Forgot your password?</div>

          {success && <LogInSuccess success={success} />}
          {error && <LogInError error={error} />}
          <div className="verify form-container">
            <div>
              <Label className="tw-text-sm tw-font-semibold">Email</Label>
              <input
                type="email"
                name="email"
                className="bbk-simple-text-input medium"
                autoComplete="on"
                placeholder="you@domain.com"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={sending}
              />
            </div>
            <SButton
              disabled={sending}
              type="submit"
              variant="primary"
              size="large"
              fullWidth
            >
              {sending ? 'Sending...' : 'Send reset email'}
            </SButton>
          </div>
        </div>
      </form>
      <LogInTrouble link={{ path: LogInPaths.signIn, copy: 'Sign in' }} />
    </div>
  );
};
